
import { defineComponent } from "vue";
export default defineComponent({
  name: "SelectOption",
  props: {
    data: Object,
    editStatus: Boolean,
  },
  setup() {
    return {};
  },
});
